@if (date$ | async; as date) {
    <time [dateTime]="date.raw">{{ date.readable }}</time>
}
